export function formatBTC(amount: number): string {
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 8,
  }).format(amount)
}

export function formatUSD(amount: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount)
}

export function formatPercent(value: number): string {
  return `${value.toFixed(2)}%`
}

export function formatNumber(value: number): string {
  return new Intl.NumberFormat('en-US').format(value)
}

export function shortenAddress(
  address: string,
  startChars = 8,
  endChars = 6,
): string {
  if (address.length <= startChars + endChars) return address
  return `${address.slice(0, startChars)}...${address.slice(-endChars)}`
}

export function copyToClipboard(text: string): Promise<void> {
  return navigator.clipboard.writeText(text)
}

export function formatDate(dateString: string): string {
  if (dateString === 'Never') return 'Never'
  const date = new Date(dateString)
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  }).format(date)
}

export function getBlockchainExplorerUrl(
  address: string,
  explorer: 'blockchain' | 'blockchair' | 'bitinfocharts' = 'blockchain',
): string {
  const explorers = {
    blockchain: `https://www.blockchain.com/explorer/addresses/btc/${address}`,
    blockchair: `https://blockchair.com/bitcoin/address/${address}`,
    bitinfocharts: `https://bitinfocharts.com/bitcoin/address/${address}`,
  }
  return explorers[explorer]
}
